import React from 'react';

function Barbados(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124192)">
        <mask
          id="mask0_800_124192"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124192)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24.75 0H36V24H24.75V0Z"
            fill="#2E42A5"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.25 0H24.75V24H11.25V0Z"
            fill="#FECA00"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0H11.25V24H0V0Z"
            fill="#2E42A5"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.9385 15.6678C21.15 14.3782 22.6494 11.5753 22.6494 11.5753L23.3447 9.93074L20.5888 10.7256L21.241 11.0273L19.9647 14.2258L19.0007 14.0212V7.85251L19.7633 7.80301L17.8823 5.37152L16.0456 7.85251H16.9318V14.0212L15.8459 14.1826L15.0713 10.9479L15.5184 10.6147L12.52 10.1233L13.4152 11.5916C13.4152 11.5916 14.62 14.1082 15.0713 15.6678L16.9318 15.5404V17.9375H19.0007V15.5404L20.9385 15.6678Z"
            fill="black"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124192">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Barbados;
